import { render } from "./SwiperSlide.vue?vue&type=template&id=716a227c"
const script = {}

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.27_typescript@5.3.3__webpack@5.91.0_webpack-cli@5.1.4_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__